/* Metacards product page v3 — works across separate sections and blocks.
   Uses event delegation, so sections can be added, moved or reloaded in the theme editor. */
(function () {
  'use strict';
  if (window.__mcPdp) return; window.__mcPdp = true;
  var d = document;
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function rupees(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function track(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mc_pdp_' + name, data || {}); } catch (e) {} }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function variants() { try { return JSON.parse(q('[data-mp-variants]').textContent); } catch (e) { return []; } }
  function byId(id) { return variants().filter(function (v) { return String(v.id) === String(id); })[0]; }
  function setText(sel, txt) { qa(sel).forEach(function (el) { el.textContent = txt; }); }

  /* ---------- gallery ---------- */
  var active = 0, swiped = false, lockUntil = 0;
  function slides() { return qa('.mp__slide'); }
  function setActive(i) { active = i; qa('[data-mp-dot]').forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
  function goTo(i, smooth) {
    var trk = q('[data-mp-track]'), sl = slides(); if (!trk || !sl[i]) return; lockUntil = Date.now() + 900;
    trk.scrollTo({ left: sl[i].offsetLeft - trk.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' }); setActive(i);
  }
  var st;
  d.addEventListener('scroll', function (e) {
    var trk = e.target; if (!trk.matches || !trk.matches('[data-mp-track]')) return;
    clearTimeout(st);
    st = setTimeout(function () {
      var i = Math.round(trk.scrollLeft / trk.clientWidth);
      if (i !== active && Date.now() > lockUntil) { setActive(i); if (!swiped) { swiped = true; track('gallery_swipe', { index: i }); } }
    }, 70);
  }, true);
  d.addEventListener('keydown', function (e) {
    if (!e.target.matches || !e.target.matches('[data-mp-track]')) return;
    if (e.key === 'ArrowRight') { goTo(Math.min(slides().length - 1, active + 1)); e.preventDefault(); }
    if (e.key === 'ArrowLeft') { goTo(Math.max(0, active - 1)); e.preventDefault(); }
  });

  /* tilt + glare on the first photo */
  if (!reduce) {
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var tilt = e.target.closest && e.target.closest('.mp__slide.is-tilt'); var pic = tilt && q('.mp__pic', tilt); if (!pic) return;
      var r = tilt.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      tilt.classList.add('is-live');
      pic.style.setProperty('--tx', ((.5 - y) * 14).toFixed(2) + 'deg'); pic.style.setProperty('--ty', ((x - .5) * 20).toFixed(2) + 'deg');
      pic.style.setProperty('--gx', (x * 100) + '%'); pic.style.setProperty('--gy', (y * 100) + '%'); pic.style.setProperty('--go', '1');
    });
    d.addEventListener('pointerout', function (e) {
      var tilt = e.target.closest && e.target.closest('.mp__slide.is-tilt'); if (!tilt || tilt.contains(e.relatedTarget)) return;
      var pic = q('.mp__pic', tilt); tilt.classList.remove('is-live'); if (pic) ['--tx', '--ty', '--gx', '--gy', '--go'].forEach(function (p) { pic.style.removeProperty(p); });
    });
    window.addEventListener('deviceorientation', function (e) {
      if (e.gamma == null) return; var pic = q('.mp__slide.is-tilt .mp__pic'); if (!pic) return;
      var g = Math.max(-20, Math.min(20, e.gamma)), b = Math.max(-20, Math.min(20, (e.beta || 45) - 45));
      pic.style.setProperty('--ty', (g * .45).toFixed(2) + 'deg'); pic.style.setProperty('--tx', (-b * .35).toFixed(2) + 'deg');
      pic.style.setProperty('--gx', (50 + g * 2) + '%'); pic.style.setProperty('--gy', (40 + b * 2) + '%'); pic.style.setProperty('--go', '.8');
    }, { passive: true });
  }

  /* ---------- clicks ---------- */
  var lastFocus = null;
  d.addEventListener('click', function (e) {
    var t = e.target;
    var dot = t.closest('[data-mp-dot]'); if (dot) { goTo(+dot.getAttribute('data-mp-dot')); return; }
    var img = t.closest('.mp__slide img, [data-mp-zoom] img');
    if (img) {
      var lb = q('[data-mp-lb]'), li = q('[data-mp-lb-img]'); if (!lb) return;
      if (lb.parentNode !== d.body) d.body.appendChild(lb);
      lastFocus = img; li.src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=2000'); li.alt = img.alt;
      lb.hidden = false; d.body.classList.add('mc-lock'); q('[data-mp-lb-close]', lb).focus(); track('zoom'); return;
    }
    var lbx = t.closest('[data-mp-lb]');
    if (lbx && (t === lbx || t.hasAttribute('data-mp-lb-close'))) { closeLb(); return; }
    var ret = q('[data-mp-return]');
    if (t.closest('[data-mp-addbag]')) { if (ret) ret.value = '/cart'; return; }
    var sub = t.closest('[data-mp-cta],[data-mp-sticky-btn],[data-mp-end-btn]');
    if (sub) {
      if (ret) ret.value = '/checkout';
      if (sub.hasAttribute('data-mp-sticky-btn')) track('sticky_cta_click');
      if (sub.hasAttribute('data-mp-end-btn')) track('end_cta_click');
      return;
    }
    if (t.closest('[data-mp-wa]')) { track('whatsapp_click'); return; }
    var more = t.closest('.mp__more-it'); if (more) track('more_design_click', { url: more.getAttribute('href') });
  });
  function closeLb() { var lb = q('[data-mp-lb]'); if (!lb) return; lb.hidden = true; d.body.classList.remove('mc-lock'); if (lastFocus) lastFocus.focus(); }
  d.addEventListener('keydown', function (e) { var lb = q('[data-mp-lb]'); if (e.key === 'Escape' && lb && !lb.hidden) closeLb(); });

  /* ---------- variant ---------- */
  function applyVariant(v, fromUser) {
    if (!v) return;
    var idIn = q('[data-mp-id]'); if (idIn) idIn.value = v.id;
    var p = rupees(v.price), save = v.compare > v.price ? v.compare - v.price : 0;
    setText('[data-mp-price]', p); setText('[data-mp-cta-price]', p);
    setText('[data-mp-vlabel]', v.title); setText('[data-mp-var]', v.title);
    qa('[data-mp-compare]').forEach(function (el) { el.hidden = !save; el.textContent = rupees(v.compare); });
    qa('[data-mp-save]').forEach(function (el) { el.hidden = !save; el.textContent = 'Save ' + rupees(save); });
    qa('[data-mp-cta]').forEach(function (b) { b.disabled = !v.available; var l = q('[data-mp-cta-label]', b); if (l) l.textContent = v.available ? (b.getAttribute('data-label') || l.textContent) : 'Sold out'; });
    qa('[data-mp-back]').forEach(function (b) {
      if (v.fin) b.className = b.className.replace(/fin--[\w-]+/, 'fin--' + v.fin);
      var on = false;
      qa('[data-back-for]', b).forEach(function (im) { var m = im.getAttribute('data-back-for') === String(v.id); im.hidden = !m; if (m) { on = true; im.loading = 'eager'; } });
      b.classList.toggle('is-photo', on);
    });
    qa('[data-mp-front] img').forEach(function (i) { if (v.img) { i.removeAttribute('srcset'); i.src = v.img; } });
    qa('.mp-sticky__img img').forEach(function (i) { if (v.thumb) { i.removeAttribute('srcset'); i.src = v.thumb; } });
    qa('[data-360-for]').forEach(function (w) { var m = w.getAttribute('data-360-for') === String(v.id), vid = q('video', w); w.hidden = !m; if (vid) { if (m && spinVisible) vid.play().catch(function () {}); else vid.pause(); } });
    if (window.mcPay && v.fin) window.mcPay.setFinish(v.fin);
    if (v.media) slides().forEach(function (s, i) { if (+s.getAttribute('data-media-id') === v.media) goTo(i, fromUser); });
    if (fromUser) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      track('variant_selected', { variant_id: v.id, title: v.title });
    }
  }
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-mp-variant]') || t.matches('[data-mp-select]')) { applyVariant(byId(t.value), true); return; }
    if (t.name === 'properties[Chip size]') { var fs = t.closest('fieldset'); if (fs) fs.classList.remove('is-missing'); track('chip_size_selected', { size: t.value }); return; }
    if (t.matches('[data-mp-method]')) {
      qa('.mp__opt').forEach(function (o) { o.classList.toggle('is-on', o.contains(t)); });
      track('chip_method_selected', { method: t.value });
    }
  });

  /* ---------- name: live on the card back and the 3D card ---------- */
  var nameTracked = false;
  d.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches('[data-mp-name]')) return;
    var n = t.value.trim().toUpperCase().slice(0, 24);
    qa('[data-mp-backname]').forEach(function (el) { el.textContent = n || el.getAttribute('data-ph') || t.placeholder; });
    if (window.mcPay) window.mcPay.setName(n || t.placeholder);
    if (!nameTracked && n) { nameTracked = true; track('name_started'); }
  });

  /* ---------- submit ---------- */
  d.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-mp-form]')) return;
    var chips = qa('input[name="properties[Chip size]"]');
    if (chips.length && !chips.some(function (c) { return c.checked; })) {
      e.preventDefault();
      var box = chips[0].closest('fieldset'); if (box) { box.classList.add('is-missing'); box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      track('chip_size_missing'); return;
    }
    var idIn = q('[data-mp-id]'), chk = q('[data-mp-variant]:checked'), sel = q('[data-mp-select]');
    if (idIn && chk) idIn.value = chk.value; else if (idIn && sel) idIn.value = sel.value;
    var nm = q('[data-mp-name]'); if (nm) nm.value = nm.value.trim().toUpperCase();
    qa('[data-mp-cta]').forEach(function (b) { b.classList.add('is-busy'); setTimeout(function () { b.classList.remove('is-busy'); }, 4000); });
  });

  /* ---------- FAQ / quick answers ---------- */
  d.addEventListener('toggle', function (e) {
    var t = e.target; if (!t.matches || !t.open) return;
    if (t.matches('[data-mp-quick]')) track('quick_answer_open', { q: (q('summary', t) || {}).textContent });
    else if (t.matches('[data-mp-faq]')) track('faq_open', { q: (q('summary', t) || {}).textContent });
  }, true);

  /* ---------- 360° view: loop when visible, drag (or arrow keys) to turn ---------- */
  var spinVisible = false, spinIO;
  function spinVid() { var w = qa('[data-360-for]').filter(function (x) { return !x.hidden; })[0]; return w && q('video', w); }
  function spin() {
    var box = q('[data-360]'); if (spinIO) spinIO.disconnect(); if (!box) return;
    if ('IntersectionObserver' in window) {
      spinIO = new IntersectionObserver(function (en) { en.forEach(function (x) { spinVisible = x.isIntersecting; var v = spinVid(); if (!v) return; if (spinVisible && !reduce && !box.classList.contains('is-drag')) v.play().catch(function () {}); else v.pause(); }); }, { threshold: .3 });
      spinIO.observe(box);
    }
  }
  var drag = null, resume;
  d.addEventListener('pointerdown', function (e) {
    var box = e.target.closest && e.target.closest('[data-360]'); var v = box && spinVid(); if (!v || !v.duration) return;
    clearTimeout(resume); v.pause(); box.classList.add('is-drag', 'is-used');
    drag = { box: box, v: v, x: e.clientX, t: v.currentTime, w: box.clientWidth };
    try { box.setPointerCapture(e.pointerId); } catch (er) {}
    if (!drag.used) { drag.used = true; track('spin_360_drag'); }
  });
  d.addEventListener('pointermove', function (e) {
    if (!drag) return; var dur = drag.v.duration, nt = drag.t - (e.clientX - drag.x) / drag.w * dur;
    drag.v.currentTime = ((nt % dur) + dur) % dur;
  });
  function endDrag() { if (!drag) return; var dd = drag; drag = null; dd.box.classList.remove('is-drag'); resume = setTimeout(function () { if (spinVisible && !reduce) dd.v.play().catch(function () {}); }, 1800); }
  d.addEventListener('pointerup', endDrag); d.addEventListener('pointercancel', endDrag);
  d.addEventListener('keydown', function (e) {
    var box = e.target.matches && e.target.matches('[data-360]') && e.target; var v = box && spinVid(); if (!v || !v.duration) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); v.pause(); box.classList.add('is-used'); v.currentTime = (v.currentTime + (e.key === 'ArrowRight' ? -1 : 1) * v.duration / 24 + v.duration) % v.duration; }
  });

  /* ---------- sticky bar ---------- */
  var io1, io2;
  function sticky() {
    var bar = q('[data-mp-sticky]'), ctas = q('[data-mp-ctas]');
    if (io1) io1.disconnect(); if (io2) io2.disconnect();
    qa('body > .mp-sticky').forEach(function (old) { if (old !== bar) old.remove(); });
    if (!bar || !ctas || !('IntersectionObserver' in window)) return;
    if (bar.parentNode !== d.body) d.body.appendChild(bar);
    var ctaVisible = true, ctaAbove = false, endVisible = false;
    function sync() {
      var on = !ctaVisible && ctaAbove && !endVisible;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var b = q('button', bar); if (b) b.tabIndex = on ? 0 : -1;
    }
    io1 = new IntersectionObserver(function (en) { en.forEach(function (x) { ctaVisible = x.isIntersecting; ctaAbove = x.boundingClientRect.top < 0; }); sync(); });
    io1.observe(ctas);
    var end = q('[data-mp-end]') || q('footer');
    if (end) { io2 = new IntersectionObserver(function (en) { en.forEach(function (x) { endVisible = x.isIntersecting; }); sync(); }); io2.observe(end); }
  }

  function boot() {
    var chk = q('[data-mp-variant]:checked'); var v = chk && byId(chk.value);
    if (v && v.media) applyVariant(v, false);
    sticky(); spin();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
})();
